/**
 * @file paddle 教程
 * @author FengGuang(fengguang01@baidu.com)
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import 'element-qsa-scope';
import React from 'react';
import ReactDOM from 'react-dom';

import TutorialsRoute from './TutorialsRoute';

import './style/index.less';



ReactDOM.render(<TutorialsRoute />, document.getElementById('root'));


